var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOfflineEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3716"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 11.5,
    cy: 12.2949,
    r: 11.5,
    fill: "#FE8FB6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.5123 8.5611C15.3065 8.5611 17.9515 10.8103 19.1023 12.0231C17.9834 13.3948 15.3385 16.0286 11.5123 16.0286C7.98244 16.0286 5.17932 13.3881 3.94307 11.9909C5.13539 10.761 7.78998 8.5611 11.5123 8.5611ZM11.5123 7.0676C5.46762 7.0676 1.91699 11.9596 1.91699 11.9596C1.91699 11.9596 5.77828 17.5221 11.5123 17.5221C17.688 17.5221 21.0837 11.9596 21.0837 11.9596C21.0837 11.9596 17.6568 7.0676 11.5123 7.0676ZM11.5003 9.30786C9.73619 9.30786 8.30588 10.646 8.30588 12.2949C8.30588 13.9444 9.73619 15.2819 11.5003 15.2819C13.2645 15.2819 14.6948 13.9444 14.6948 12.2949C14.6948 10.646 13.2645 9.30786 11.5003 9.30786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1",
    d: "M16.3047 5.63773L4.69176 17.1546",
    stroke: "black",
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineEye);
export default __webpack_public_path__ + "static/media/OfflineEye.faf6357308b2f8bcaccd1d083436ac4f.svg";
export { ForwardRef as ReactComponent };